module.exports = __webpack_public_path__ + "static/media/likes.fc6e8dc5.svg";